import { Registry } from '@react-registry'

export const boldDeserializer = () => {
  return { bold: true }
}

Registry.register(boldDeserializer, { id: 'B', registry: 'v2.inline-deserializer' })
Registry.register(boldDeserializer, { id: 'STRONG', registry: 'v2.inline-deserializer' })
